import { z } from 'zod';
import { endpoint } from './endpoint.js';
import {
  MediaFormatGroupAdminSchema,
  CreateFormatGroupSchema,
  UpdateFormatGroupSchema,
  DeactivateFormatGroupEffectsSchema,
} from '../schemas/format-group-admin.js';

export const adminFormatGroups = {
  /** GET /admin/format-groups — list all groups (including inactive) */
  listGroups: endpoint(
    'GET',
    '/admin/format-groups',
    z.object({}),
    z.array(MediaFormatGroupAdminSchema),
  ),

  /** GET /admin/format-groups/:id — single group */
  getGroup: endpoint(
    'GET',
    '/admin/format-groups/:id',
    z.object({ id: z.number() }),
    MediaFormatGroupAdminSchema,
  ),

  /** POST /admin/format-groups — create */
  createGroup: endpoint(
    'POST',
    '/admin/format-groups',
    CreateFormatGroupSchema,
    MediaFormatGroupAdminSchema,
  ),

  /** PATCH /admin/format-groups/:id — update name/sortOrder/isActive */
  updateGroup: endpoint(
    'PATCH',
    '/admin/format-groups/:id',
    z.object({ id: z.number() }).merge(UpdateFormatGroupSchema),
    MediaFormatGroupAdminSchema,
  ),

  /** DELETE /admin/format-groups/:id — deactivate group */
  deleteGroup: endpoint(
    'DELETE',
    '/admin/format-groups/:id',
    z.object({ id: z.number() }),
    MediaFormatGroupAdminSchema,
  ),

  /** GET /admin/format-groups/:id/deactivate-effects */
  getDeactivateEffects: endpoint(
    'GET',
    '/admin/format-groups/:id/deactivate-effects',
    z.object({ id: z.number() }),
    DeactivateFormatGroupEffectsSchema,
  ),
};
